import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getAuth, EmailAuthProvider, GoogleAuthProvider } from "firebase/auth";
import { StyledFirebaseAuth } from "react-firebaseui";
import { AuthContext } from "./App";

export default function SignInPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useContext(AuthContext);

  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
    if (currentUser) {
      navigate(from, { replace: true });
    }
  }, [currentUser, from, navigate]);

  const auth = getAuth();

  const uiConfig = {
    signInOptions: [
      {
        provider: EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: true,
      },
      {
        provider: GoogleAuthProvider.PROVIDER_ID,
      },
    ],
    signInFlow: "popup",
    callbacks: {
      signInSuccessWithAuthResult: () => {
        navigate(from, { replace: true });
        return false;
      },
    },
    credentialHelper: "none",
  };

  return (
    <div className="card bg-light">
      <div className="container card-body">
        <StyledFirebaseAuth firebaseAuth={auth} uiConfig={uiConfig} />
      </div>
    </div>
  );
}
